import { Shield, FileCheck, Award, ChevronRight, Download, Globe, Building, Calendar, MapPin, Eye } from 'lucide-react';
import { API_URL } from '../config/api';

const LicenciasPage = () => {

  return (
    <div data-testid="licencias-page" className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white/95 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between">
          <a href="/" className="text-sm font-semibold text-[#1D1D1B]">
            Club<span className="text-[#45A0EE]">Viajemos</span> <span className="text-slate-400">| Travel Empire</span>
          </a>
          <a href="/precios" className="text-sm text-[#45A0EE] hover:text-[#3688cc] font-medium flex items-center gap-1">
            Ver Planes <ChevronRight className="h-3 w-3" />
          </a>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-4 py-12 md:py-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-[#1D1D1B] flex items-center justify-center">
              <Shield className="h-6 w-6 text-[#c9a227]" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-black text-[#1D1D1B]">Licencias y Registros</h1>
              <p className="text-slate-500 text-sm">Documentacion legal de Club Viajemos / Travel Empire</p>
            </div>
          </div>
          <p className="text-slate-600 text-base max-w-3xl leading-relaxed">
            Club Viajemos opera bajo <span className="font-semibold">TONS OF LEADS LLC</span>, una empresa debidamente registrada y licenciada 
            en el Estado de Florida como Seller of Travel. Todos nuestros documentos legales estan disponibles para consulta publica.
          </p>
        </div>
      </section>

      {/* Company Info */}
      <section className="max-w-5xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          <div className="bg-white rounded-xl border border-slate-200 p-5">
            <Building className="h-5 w-5 text-[#45A0EE] mb-2" />
            <p className="text-xs text-slate-400 font-medium uppercase tracking-wider mb-1">Empresa</p>
            <p className="text-[#1D1D1B] font-bold">TONS OF LEADS LLC</p>
            <p className="text-slate-500 text-xs mt-1">Establecida: 6 de Marzo, 2014</p>
          </div>
          <div className="bg-white rounded-xl border border-slate-200 p-5">
            <MapPin className="h-5 w-5 text-[#80C753] mb-2" />
            <p className="text-xs text-slate-400 font-medium uppercase tracking-wider mb-1">Ubicacion</p>
            <p className="text-[#1D1D1B] font-bold text-sm">800 SE 4TH AVE STE 506</p>
            <p className="text-slate-500 text-xs mt-1">Hallandale Beach, Florida 33009</p>
          </div>
          <div className="bg-white rounded-xl border border-slate-200 p-5">
            <Globe className="h-5 w-5 text-[#c9a227] mb-2" />
            <p className="text-xs text-slate-400 font-medium uppercase tracking-wider mb-1">Representante Legal</p>
            <p className="text-[#1D1D1B] font-bold">Carlos A. Fernandez</p>
            <p className="text-slate-500 text-xs mt-1">President & Registered Agent</p>
          </div>
        </div>

        {/* Licenses */}
        <h2 className="text-lg font-black text-[#1D1D1B] uppercase tracking-wide mb-5">Documentos de Licencia</h2>
        <div className="space-y-4">
          {/* FDACS - Florida Seller of Travel */}
          <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-16 bg-[#1D1D1B] flex items-center justify-center py-4 md:py-0">
                <FileCheck className="h-6 w-6 text-[#c9a227]" />
              </div>
              <div className="flex-1 p-5 md:p-6">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="font-bold text-[#1D1D1B]">Florida Seller of Travel Registration</h3>
                      <span className="bg-[#80C753]/15 text-[#80C753] text-[10px] font-bold px-2 py-0.5 rounded-full">ACTIVA</span>
                    </div>
                    <p className="text-slate-500 text-sm mb-3">Registro bajo el Florida Sellers of Travel Act — FDACS (Florida Department of Agriculture and Consumer Services)</p>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Licencia No.</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">ST39568</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Entidad</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">TONS OF LEADS LLC</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Estado</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">Florida, USA</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Website</p>
                        <p className="text-[#45A0EE] font-bold text-sm">clubviajemos.com</p>
                      </div>
                    </div>
                  </div>
                  <a
                    href="/licencias/fdacs"
                    data-testid="view-fdacs"
                    className="flex items-center gap-2 bg-[#1D1D1B] hover:bg-[#333] text-white font-medium px-4 py-2.5 rounded-lg transition-colors text-sm whitespace-nowrap flex-shrink-0"
                  >
                    <Eye className="h-4 w-4" />
                    Ver Documento
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Florida Seller of Travel — Registration Certificate (renovado 2026) */}
          <div className="bg-white rounded-xl border-2 border-[#c9a227]/40 overflow-hidden ring-1 ring-[#c9a227]/10">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-16 bg-[#1D1D1B] flex items-center justify-center py-4 md:py-0">
                <FileCheck className="h-6 w-6 text-[#c9a227]" />
              </div>
              <div className="flex-1 p-5 md:p-6">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                  <div>
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <h3 className="font-bold text-[#1D1D1B]">Florida Seller of Travel — Registration Certificate</h3>
                      <span className="bg-[#c9a227]/15 text-[#c9a227] text-[10px] font-bold px-2 py-0.5 rounded-full">VIGENTE 2026</span>
                      <span className="bg-[#45A0EE]/15 text-[#45A0EE] text-[10px] font-bold px-2 py-0.5 rounded-full">RENOVADO</span>
                    </div>
                    <p className="text-slate-500 text-sm mb-3">Certificado oficial emitido por FDACS — TONS OF LEADS LLC operando bajo el nombre comercial (DBA) <span className="font-semibold text-[#1D1D1B]">VIAJEMOS</span>.</p>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Registro No.</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">ST39568</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">DBA</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">VIAJEMOS</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Emitido</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">05 Mayo 2026</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Expira</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">25 Nov 2026</p>
                      </div>
                    </div>
                  </div>
                  <a
                    href="/licencias/florida-certificate"
                    data-testid="view-florida-certificate"
                    className="flex items-center gap-2 bg-[#1D1D1B] hover:bg-[#333] text-white font-medium px-4 py-2.5 rounded-lg transition-colors text-sm whitespace-nowrap flex-shrink-0"
                  >
                    <Eye className="h-4 w-4" />
                    Ver Certificado
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Surety Bond */}
          <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-16 bg-[#1D1D1B] flex items-center justify-center py-4 md:py-0">
                <Award className="h-6 w-6 text-[#c9a227]" />
              </div>
              <div className="flex-1 p-5 md:p-6">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="font-bold text-[#1D1D1B]">Florida Seller of Travel Surety Bond</h3>
                      <span className="bg-[#80C753]/15 text-[#80C753] text-[10px] font-bold px-2 py-0.5 rounded-full">VIGENTE</span>
                    </div>
                    <p className="text-slate-500 text-sm mb-3">Fianza de garantia requerida por el Estado de Florida para proteccion del consumidor — emitida por suretybonds.com</p>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Cobertura</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">$25,000 USD</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Principal</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">TONS OF LEADS LLC</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Vigencia</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">10/2024 — 10/2026</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-slate-400 uppercase font-medium">Emisor</p>
                        <p className="text-[#1D1D1B] font-bold text-sm">suretybonds.com</p>
                      </div>
                    </div>
                  </div>
                  <a
                    href="/licencias/bond"
                    data-testid="view-surety"
                    className="flex items-center gap-2 bg-[#1D1D1B] hover:bg-[#333] text-white font-medium px-4 py-2.5 rounded-lg transition-colors text-sm whitespace-nowrap flex-shrink-0"
                  >
                    <Eye className="h-4 w-4" />
                    Ver Documento
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sunbiz - Florida Division of Corporations */}
        <h2 className="text-lg font-black text-[#1D1D1B] uppercase tracking-wide mt-10 mb-5">Registro Estatal — Florida Division of Corporations</h2>
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-16 bg-[#1D1D1B] flex items-center justify-center py-4 md:py-0">
              <Building className="h-6 w-6 text-[#c9a227]" />
            </div>
            <div className="flex-1 p-5 md:p-6">
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-bold text-[#1D1D1B]">Florida Limited Liability Company</h3>
                    <span className="bg-[#80C753]/15 text-[#80C753] text-[10px] font-bold px-2 py-0.5 rounded-full">ACTIVA</span>
                  </div>
                  <p className="text-slate-500 text-sm mb-3">Registro publico en Sunbiz.org — Florida Department of State, Division of Corporations. Empresa activa e ininterrumpida desde 2014.</p>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-3">
                    <div>
                      <p className="text-[10px] text-slate-400 uppercase font-medium">Document No.</p>
                      <p className="text-[#1D1D1B] font-bold text-sm">L14000038363</p>
                    </div>
                    <div>
                      <p className="text-[10px] text-slate-400 uppercase font-medium">FEI/EIN</p>
                      <p className="text-[#1D1D1B] font-bold text-sm">46-5014972</p>
                    </div>
                    <div>
                      <p className="text-[10px] text-slate-400 uppercase font-medium">Fecha de Registro</p>
                      <p className="text-[#1D1D1B] font-bold text-sm">03/07/2014</p>
                    </div>
                    <div>
                      <p className="text-[10px] text-slate-400 uppercase font-medium">Estado</p>
                      <p className="text-[#80C753] font-bold text-sm">ACTIVE</p>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-3">
                    <div>
                      <p className="text-[10px] text-slate-400 uppercase font-medium">Manager</p>
                      <p className="text-[#1D1D1B] font-bold text-sm">Carlos Fernandez</p>
                    </div>
                    <div>
                      <p className="text-[10px] text-slate-400 uppercase font-medium">Direccion Principal</p>
                      <p className="text-[#1D1D1B] font-bold text-sm">800 SE 4th Ave, Hallandale FL</p>
                    </div>
                    <div>
                      <p className="text-[10px] text-slate-400 uppercase font-medium">Reportes Anuales</p>
                      <p className="text-[#1D1D1B] font-bold text-sm">2014 — 2026 (consecutivos)</p>
                    </div>
                  </div>
                  <p className="text-[10px] text-slate-400">Fuente: Florida Department of State — Division of Corporations (Sunbiz.org)</p>
                </div>
                <a
                  href="https://search.sunbiz.org/Inquiry/CorporationSearch/SearchResultDetail?inquirytype=EntityName&directionType=Initial&searchNameOrder=TONSLEADS%20L140000383630&aggregateId=flal-l14000038363-7394d12f-0dfa-4947-9fbc-9f1d128b6fa5&searchTerm=tons%20of%20leads&listNameOrder=TONSLEADS%20L140000383630"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="sunbiz-link"
                  className="flex items-center gap-2 bg-[#1D1D1B] hover:bg-[#333] text-white font-medium px-4 py-2.5 rounded-lg transition-colors text-sm whitespace-nowrap flex-shrink-0"
                >
                  <Globe className="h-4 w-4" />
                  Ver en Sunbiz.org
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Trust banner */}
        <div className="mt-10 bg-[#1D1D1B] rounded-xl p-6 md:p-8 text-center">
          <Shield className="h-8 w-8 text-[#c9a227] mx-auto mb-3" />
          <h3 className="text-white font-bold text-lg mb-2">Operamos con total transparencia</h3>
          <p className="text-slate-400 text-sm max-w-xl mx-auto leading-relaxed">
            Club Viajemos / Travel Empire esta comprometido con la legalidad y la proteccion de sus agentes y clientes. 
            Todas nuestras operaciones cumplen con las regulaciones federales y estatales de los Estados Unidos.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm font-semibold text-[#1D1D1B]">
              Club<span className="text-[#45A0EE]">Viajemos</span>
              <span className="text-slate-300 mx-2">|</span>
              <span className="text-slate-400 font-normal text-xs">TONS OF LEADS LLC — ST39568</span>
            </p>
            <div className="flex gap-4 text-xs text-slate-400">
              <a href="/" className="hover:text-[#45A0EE] transition-colors">Inicio</a>
              <a href="/precios" className="hover:text-[#45A0EE] transition-colors">Planes</a>
              <a href="/manual27" className="hover:text-[#45A0EE] transition-colors">Manual</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LicenciasPage;
